import { z } from 'zod'
import { idSchemaV2, isId } from '../ids'
import type { MeetingId } from './model'

export const MeetingOccurrenceIdSchema = idSchemaV2('MeetingOccurrence')
export type MeetingOccurrenceId = z.infer<typeof MeetingOccurrenceIdSchema>
export const isMeetingOccurrenceId = isId(MeetingOccurrenceIdSchema)

export const MeetingOccurrenceStatusSchema = z.enum(['scheduled', 'cancelled'])
export type MeetingOccurrenceStatus = z.infer<typeof MeetingOccurrenceStatusSchema>

/** Stable identity of one occurrence of a recurring meeting. It never changes when the occurrence is rescheduled. */
export function getMeetingOccurrenceId(meetingId: MeetingId, originalScheduledStart: number): MeetingOccurrenceId {
  return `MeetingOccurrence.${meetingId}|${originalScheduledStart}`
}
